/* eslint-disable @typescript-eslint/no-unsafe-return */
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { isFunction } from 'lodash'
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

const CheckboxWidget = (props: WidgetProps) => {
  const {
    id,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    value,
    required,
    disabled,
    readonly,
    label,
    autofocus,
    onChange,
    onBlur,
    onFocus,
  } = props

  const handleChange = (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) =>
    isFunction(onChange) && onChange(checked)
  const handleBlur = ({ target: { value: targetValue } }: React.FocusEvent<HTMLButtonElement>) =>
    isFunction(onBlur) && onBlur(id, targetValue)
  const handleFocus = ({ target: { value: targetValue } }: React.FocusEvent<HTMLButtonElement>) =>
    isFunction(onFocus) && onFocus(id, targetValue)

  return (
    <FormControl fullWidth required={required}>
      <FormControlLabel
        control={
          <Checkbox
            autoFocus={autofocus}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            checked={typeof value === 'undefined' ? false : value}
            disabled={disabled || readonly}
            id={id}
            required={required}
            onBlur={handleBlur}
            onChange={handleChange}
            onFocus={handleFocus}
          />
        }
        label={label}
      />
    </FormControl>
  )
}

export default CheckboxWidget
